/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Record from 'Shared/components/SalesforceRecordModal/Record';
import { externalAPICallFromRecommendation } from 'Shared/actions/recommendations';
import { getSalesforceReferenceFieldOptions } from 'Shared/api/index';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function createRecordInput(action) {
  const recordInput = {};
  recordInput.apiName = action.apiName;
  recordInput.fields = {};
  Object.keys(action.editValues).map(field => {
    let inputValue = action.editValues[field].current;
    if (action.editValues[field].original === null && inputValue === '') {
      // React doesn't like nulls in <select>
      inputValue = null;
    }

    const dataType = action.objectInfo.fields[field].dataType;
    if (dataType === 'Boolean') {
      recordInput.fields[field] = inputValue === 'true';
    } else if (dataType === 'Int') {
      recordInput.fields[field] = parseInt(inputValue);
    } else if (dataType === 'Currency' || dataType === 'Double' || dataType === 'Percent') {
      recordInput.fields[field] = parseFloat(inputValue);
    } else {
      // By default use a string.
      recordInput.fields[field] = inputValue;
    }
  });

  return recordInput.fields;
}

class SalesforceRecordModal extends Component {
  constructor(props) {
    super(props);
    this.onSaveNewClick = this.onSaveNewClick.bind(this);
    this.onFieldValueUpdate = this.onFieldValueUpdate.bind(this);
    this.onEditDepGraph = this.onEditDepGraph.bind(this);
    this.onDepGraphClose = this.onDepGraphClose.bind(this);
    this.onDepGraphFieldValueUpdate = this.onDepGraphFieldValueUpdate.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onCloneClick = this.onCloneClick.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.loadSalesforceReferenceFieldOptions = this.loadSalesforceReferenceFieldOptions.bind(this);
  }

  onToggle() {
    this.props.dispatch({
      type: 'CLOSE_SALESFORCE_RECORD_MODAL',
    });
  }

  onBackClick() {
    console.log('onBackClick');
  }

  onCloneClick(creds, id, apiName, recordType, context) {
    console.log('onCloneClick');
  }

  onDeleteClick(creds, id) {
    console.log('onDeleteClick');
  }

  onDepGraphFieldValueUpdate(field, value, picklists, modalFields, rootField, fieldTree) {
    console.log('onDepGraphFieldValueUpdate');
  }

  onDepGraphClose(mode) {
    console.log('onDepGraphClose');
  }

  onEditDepGraph(picklists, modalFields, editValues, fieldTree, prevMode) {
    console.log('onEditDepGraph');
  }

  onEditClick(creds, apiName, recordType) {
    console.log('onEditClick');
  }

  onSaveClick(creds, id, objectInfo, editValues) {
    console.log('onSaveClick');
  }

  onFieldValueUpdate(field, value) {
    this.props.dispatch({
      type: 'UPDATE_SALESFORCE_RECORD_MODAL_FIELD_VALUE',
      field,
      value,
    });
  }

  onSaveNewClick(creds, apiName, objectInfo, editValues) {
    const { button_key, recommendation_id, dispatch } = this.props;
    const additional_arguments = createRecordInput({ apiName, objectInfo, editValues });
    dispatch(externalAPICallFromRecommendation({ recommendation_id, button_key, additional_arguments }));
  }

  loadSalesforceReferenceFieldOptions({ input_value, record_type, field_name}) {
    const { recommendation_id } = this.props;
    return getSalesforceReferenceFieldOptions({ recommendation_id, input_value, record_type, field_name});
  };

  render() {
    const {
      active,
      mode,
      record,
      picklists,
      onFieldValueUpdate,
      onSaveNewClick,
      error,
      recordButtonLoading,
    } = this.props;

    let layoutMode;

    if (mode) {
      if (mode === 'Clone') {
        layoutMode = 'Edit';
      } else {
        layoutMode = mode;
      }
    }

    const any_errors = active && error && error.errors && error.errors.length > 0;

    return (
      <Modal isOpen={active} toggle={this.onToggle} centered>
        <ModalHeader toggle={this.onToggle}>
          {any_errors && 'Please correct these issues:'}
          {!any_errors && 'Please provide this information:'}

          {active && error && (
            <div>
              <div>
                {error.errors &&
                  error.errors.map(pageError => (
                    <div key={pageError.message}>
                      <small className="text-danger">{pageError.message}</small>
                      <p />
                    </div>
                  ))}
              </div>
            </div>
          )}
        </ModalHeader>
        <ModalBody>
          {active && (
            <Record
              recordView={record}
              picklists={picklists}
              error={error}
              layoutMode={layoutMode}
              uiMode={mode}
              onFieldValueUpdate={this.onFieldValueUpdate}
              onSaveNewClick={this.onSaveNewClick}
              onEditDepGraph={this.onEditDepGraph}
              onDepGraphClose={this.onDepGraphClose}
              onDepGraphFieldValueUpdate={this.onDepGraphFieldValueUpdate}
              onBackClick={this.onBackClick}
              onCloneClick={this.onCloneClick}
              onDeleteClick={this.onDeleteClick}
              onEditClick={this.onEditClick}
              onSaveClick={this.onSaveClick}
              loadSalesforceReferenceFieldOptions={this.loadSalesforceReferenceFieldOptions}
              recordButtonLoading={recordButtonLoading}
            />
          )}
        </ModalBody>
      </Modal>
    );
  }
}

SalesforceRecordModal.propTypes = {};

const mapStateToProps = (state, ownProps) => ({
  active: state.salesforce_record_modal.active,
  mode: state.salesforce_record_modal.mode,
  record: state.salesforce_record_modal.record,
  picklists: state.salesforce_record_modal.picklists,
  button_key: state.salesforce_record_modal.button_key,
  recommendation_id: state.salesforce_record_modal.recommendation_id,
  error: state.salesforce_record_modal.error,
  recordButtonLoading: !!state.button_states['salesforce_record_modal:record_button'],
});

export default connect(mapStateToProps)(SalesforceRecordModal);
